import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";

export interface DeleteCommentResponse {
  success: boolean;
  message: string;
}

interface UseDeleteCommentVariables {
  workspaceId: number;
  commentId: number;
}

export const useDeleteComment = (
  options?: UseMutationOptions<DeleteCommentResponse, Error, UseDeleteCommentVariables>,
) => {
  const userToken = useAuth()?.userToken ?? "";

  return useMutation<DeleteCommentResponse, Error, UseDeleteCommentVariables>({
    mutationFn: async ({ workspaceId, commentId }) => {
      const response = await fetch(ENDPOINTS.changelog_comment(workspaceId, commentId), {
        method: "DELETE",
        headers: authHeader(userToken),
      });

      return handleResponse(response);
    },
    ...options,
  });
};
